import React from 'react';
import Button from '../ui/Button';
import { canReviewRequest, getRequestStatusTone, isAttendanceEvent } from '../requests/requestUtils';

function DirectorRequestTable({
  filteredRequests = [],
  onOpenPersonWorkspace = null,
  onInlineDecision = null,
  onSelectRequest = () => {},
  requestActionLoading = false,
  selectedRequestId = ''
}) {
  return (
    <div className="table-card">
      <table className="role-table director-requests-table">
        <thead>
          <tr>
            <th className="director-requests-col-manager">Person</th>
            <th className="director-requests-col-station">Location</th>
            <th className="director-requests-col-type">Type</th>
            <th className="director-requests-col-dates">Dates</th>
            <th className="director-requests-col-status">Status</th>
            <th>Reason</th>
            <th className="director-requests-col-action">Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredRequests.map((request) => (
            <tr
              key={request.id}
              className={String(selectedRequestId) === String(request.id) ? 'role-request-selected' : ''}
            >
              <td className="director-requests-col-manager">{request.displayName || request.managerName || 'N/A'}</td>
              <td className="director-requests-col-station">{request.locationCode}</td>
              <td className="role-request-type-cell director-requests-col-type">
                <span className={`role-request-type-badge ${isAttendanceEvent(request) ? 'attendance' : 'pto'}`}>
                  {isAttendanceEvent(request) ? 'Attendance' : 'PTO'}
                </span>
              </td>
              <td className="director-requests-col-dates">{request.startDate} to {request.endDate}</td>
              <td className="director-requests-col-status">
                <span className={`role-status-pill ${getRequestStatusTone(request.status)}`}>
                  {request.status}
                </span>
              </td>
              <td
                className="director-requests-reason-cell"
                title={request.reason || (String(request.status || '').toLowerCase() === 'denied' ? 'Denied without a reason provided.' : 'No reason provided')}
              >
                {String(request.status || '').toLowerCase() === 'denied' ? (
                  <span className="role-reason-denied">{request.reason || 'Denied without a reason provided.'}</span>
                ) : (
                  request.reason || 'No reason provided'
                )}
              </td>
              <td className="director-requests-col-action">
                <div className="director-table-actions">
                  {(request.employeeProfileId || request.managerId) && typeof onOpenPersonWorkspace === 'function' ? (
                    <Button
                      size="sm"
                      variant="secondary"
                      onClick={() => onOpenPersonWorkspace(request)}
                    >
                      Open workspace
                    </Button>
                  ) : null}
                  {canReviewRequest(request) && onInlineDecision ? (
                    <>
                      <Button
                        size="sm"
                        title="Quick Approve"
                        aria-label="Quick Approve"
                        disabled={requestActionLoading}
                        onClick={() => onInlineDecision(request, 'approve')}
                      >
                        <i className="fas fa-check" aria-hidden="true" />
                      </Button>
                      <Button
                        size="sm"
                        variant="secondary"
                        title="Review & Deny"
                        aria-label="Review & Deny"
                        disabled={requestActionLoading}
                        onClick={() => onInlineDecision(request, 'deny')}
                      >
                        <i className="fas fa-times" aria-hidden="true" />
                      </Button>
                    </>
                  ) : null}
                  <Button
                    variant="secondary"
                    onClick={() => onSelectRequest(String(request.id))}
                  >
                    {String(selectedRequestId) === String(request.id) ? 'Viewing' : 'Open'}
                  </Button>
                </div>
              </td>
            </tr>
          ))}
          {filteredRequests.length === 0 && (
            <tr>
              <td colSpan="7">No requests match the current filters.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default DirectorRequestTable;
